module.exports = window.Wix;